/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as AccommodationDataStoreActions from './accommodation-data-store.actions';

import { Accommodation } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'AccommodationDataStore';

/* State interface */
export interface AccommodationState {
  isLoading?: boolean;
  accommodations?: Accommodation[];
  activeAccommodation?: Accommodation;
}

/* Initial values */
export const initialState: AccommodationState = {
  isLoading: null,
  accommodations: null,
  activeAccommodation: null,
};

export const reducer = createReducer(
  initialState,
  on(AccommodationDataStoreActions.GetAccommodations, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AccommodationDataStoreActions.GetAccommodationsSuccessful,
    (state, action) => ({
      ...state,
      accommodations: action.payload.accommodations,
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.GetAccommodationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AccommodationDataStoreActions.GetAccommodationById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AccommodationDataStoreActions.GetAccommodationByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.GetAccommodationByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.GetActiveAccommodationWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    AccommodationDataStoreActions.GetActiveAccommodationByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeAccommodation: action.payload.activeAccommodation,
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.GetActiveAccommodationByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AccommodationDataStoreActions.CreateAccommodation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AccommodationDataStoreActions.CreateAccommodationSuccessful,
    (state, action) => ({
      ...state,
      accommodations: [
        ...(state.accommodations ?? []),
        action.payload.accommodation,
      ],
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.CreateAccommodationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AccommodationDataStoreActions.UpdateAccommodation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AccommodationDataStoreActions.UpdateAccommodationSuccessful,
    (state, action) => ({
      ...state,
      accommodations: updateEntityInArray<Accommodation>(
        action.payload.id,
        action.payload.data,
        state.accommodations ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.UpdateAccommodationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AccommodationDataStoreActions.DeleteAccommodation, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    AccommodationDataStoreActions.DeleteAccommodationSuccessful,
    (state, action) => ({
      ...state,
      accommodations:
        state.accommodations?.filter((item) => action.payload.id !== item.id) ??
        [],
      isLoading: false,
    }),
  ),

  on(
    AccommodationDataStoreActions.DeleteAccommodationFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(AccommodationDataStoreActions.ResetState, () => initialState),
);
